const routes = [
  {
    path: "/sale/:uid",
    name: "sale",
    component:  () => import(/* webpackChunkName: "SalePage" */ "./views/SalePage")
  }
]

export default routes;
